import { useTheme } from '@mui/material';
import { blueGrey } from '@mui/material/colors';

export function useHighlightColor() {
  const vyTheme = useTheme();

  const highlightColor = vyTheme.palette.tertiary.main;
  const defaultColor = blueGrey['300'];

  return (href: string, atStart = false) => {
    if (atStart) {
      return location.pathname.startsWith(href) ? highlightColor : defaultColor;
    }

    return location.pathname.includes(href) ? highlightColor : defaultColor;
  };
}